import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';




const clientSlice = createSlice({
  name: 'clientsApp/client',
  initialState: {
	  userToAuthorize: {},
	  userToAddFile: {},
	  selectedUsersTab: 0,
	  selectedTeamTab: 0,
	  selectedChatAuthUserId: null,
  },
  reducers: {
    setUserToAuthorize: {
      reducer: (state, action) => {
        state.userToAuthorize = action.payload;
      }
    },
    setUserToAddFile: {
      reducer: (state, action) => {
        state.userToAddFile = action.payload;
      }
    },
    setSelectedUsersTab: {
      reducer: (state, action) => {
        state.selectedUsersTab = action.payload;
      }
    },
    setSelectedTeamTab: {
      reducer: (state, action) => {
        state.selectedTeamTab = action.payload;
      }
    },
    setSelectedChatAuthUserId: {
      reducer: (state, action) => {
        state.selectedChatAuthUserId = action.payload;
      }
    },
  },
});

export const selectUserToAuthorize = () => state => {
	return state.clientsApp.client.userToAuthorize;
}
export const selectUserToAddFile = () => state => {
	return state.clientsApp.client.userToAddFile;
}
export const selectSelectedUsersTab = () => state => {
	return state.clientsApp.client.selectedUsersTab;
}
export const selectSelectedTeamTab = () => state => {
	return state.clientsApp.client.selectedTeamTab;
}
export const selectSelectedChatAuthUserId = () => state => {
	return state.clientsApp.client.selectedChatAuthUserId;
}

export const { setSelectedUsersTab, setSelectedTeamTab,
               setUserToAuthorize, setUserToAddFile, setSelectedChatAuthUserId} = clientSlice.actions;

export default clientSlice.reducer;
